import { makeStyles } from 'tss-react/mui';

export const useButtonBaseWithSelectionMenuStyles = makeStyles()((theme) => ({
  menu: {
    marginTop: theme.spacing(0.3),
  },
  button: {
    justifyContent: 'space-between',
    height: '24px',
    borderRadius: theme.shape.borderRadiusLg,
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  disabledLookButton: {
    '&&': {
      color: theme.palette.text.disabled,
    },
  },
  chevron: {
    transition: theme.transitions.create('transform'),
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  chevronHidden: {
    visibility: 'hidden',
  },
}));
